import { HOTJAR_ATTR, HOTJAR_PROP, IHotjarProps } from "./types";

const testMock = {};

function compose(key: string, props: IHotjarProps) {
  const { [HOTJAR_PROP]: value } = props;

  if (!value) {
    return testMock;
  }

  return { [key]: value };
}

export function hotjarAttr(props: IHotjarProps) {
  return compose(HOTJAR_ATTR, props);
}
